import axios from "axios";

// const API_URL = "http://localhost:5000/products";
const API_URL = "https://server-1-a8513995.deta.app/products";

export const fetchProducts = (queryParams) =>
  axios.get(API_URL, { params: queryParams });

export const updateProductViewCount = (id, queryParams) =>
  axios.patch(`${API_URL}/${id}/view`, null, { params: queryParams });

export const fetchProduct = async (id, queryParams) => {
  try {
    const response = await axios.get(`${API_URL}/${id}`, {
      params: queryParams,
    });
    const responseData = await response.data;
    return responseData;
  } catch (error) {
    console.error(error);
    return null;
  }
};
